/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../../../common";
import type {
  Moar,
  MoarInterface,
} from "../../../../../../../../contracts/submodules/moar-locker/submodules/moar/contracts/moar/Moar";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "authority",
        type: "address",
      },
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurnningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "ContractBidder",
    type: "error",
  },
  {
    inputs: [],
    name: "DuplicatedMint",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedAuctionSupply",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedDiamondHandSupply",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedMaxSupply",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedMaxTicket",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPayment",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSaleOn",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTime",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "WithdrawFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "refundFailed",
    type: "event",
  },
  {
    inputs: [],
    name: "DHDAMaxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DHDATotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DIAMOND_HAND_ID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_DROP_INTERVAL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_DROP_PER_STEP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_END_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_MAX_TICKET",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_PRICE_CURVE_LENGTH",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DUTCH_AUCTION_START_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tierIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierStartTimes",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierDurations",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierMaxTicketNums",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tierTicketPrices",
        type: "uint256[]",
      },
    ],
    name: "configSales",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "diamondHandMaxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "diamondHandMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "dutchAuctionMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "dutchAuctionPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dutchAuctionStartTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tos",
        type: "address[]",
      },
    ],
    name: "privateMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "provenance",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "publicMints",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "saleOn",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "authority",
        type: "address",
      },
    ],
    name: "setAuthority",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
    ],
    name: "setDutchAuctionStartTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "provenance_",
        type: "bytes32",
      },
    ],
    name: "setProvenance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tiers",
    outputs: [
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxTicketNum",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketPrice",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum MoarBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tierId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "whitelistMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MoarConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MoarConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Moar__factory extends ContractFactory {
  constructor(...args: MoarConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    authority: PromiseOrValue<string>,
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Moar> {
    return super.deploy(
      authority,
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<Moar>;
  }
  override getDeployTransaction(
    authority: PromiseOrValue<string>,
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      authority,
      admin,
      royaltyAddress,
      overrides || {}
    );
  }
  override attach(address: string): Moar {
    return super.attach(address) as Moar;
  }
  override connect(signer: Signer): Moar__factory {
    return super.connect(signer) as Moar__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MoarInterface {
    return new utils.Interface(_abi) as MoarInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Moar {
    return new Contract(address, _abi, signerOrProvider) as Moar;
  }
}
